<div class="container-fluid">

  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
        My Leaves</h5>
      </div>

<div id="mainContent" class="container">
  <div class="row pt-2">
    <div class="col-md-3">
      <label class="mb-0">Financial Year :</label>
      <div class="form-group mb-0">
        <select
          class="form-control form-control-sm"
          [id]="'financialYear'"
          [name]="'financialYear'"
          type="text"
          [(ngModel)]="selectedFY"
          matTooltip="'select Fy year'"
          matTooltipPosition="above"
          (change)="loadLeaveSummaryForFY()"
        >
          <option class="optionColor" [value]="null">Select</option>
          <option class="optionColor"
            *ngFor="let financialYear of financialYearList"
            [ngValue]="financialYear"
          >
            {{ financialYear.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
  <div class="pt-4">
    <label>Balance Leaves : {{ userBalanceLeaves }}</label>
  </div>
  <div >
    <div class="row">
      <div class="col-md-12">
        <table class="table table-striped table-bordered table-sm">
          <thead class="">
            <tr>
              <th>Sr.No.</th>
              <th>Approver Name</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Number Of Days</th>
              <th>Leave Type</th>
              <th>Leave Request Date</th>
              <!-- <th>Balance</th> -->
              <th>Reason</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let appliedLeave of appliedLeaveList; index as i"
              id="myLeaves_{{ i + 1 }}"
            >
              <td scope="row">{{ i + 1 }}</td>
              <td *ngIf="approverList.length > 0">
                {{ appliedLeave.approver.firstName }}
                {{ appliedLeave.approver.lastName }}
              </td>
              <td *ngIf="approverList.length == 0">Self Approved</td>
              <td>{{ appliedLeave.fromDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ appliedLeave.toDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ appliedLeave.leaveDays }}</td>
              <td>{{ appliedLeave.leaveType.name }}</td>
              <td>{{ appliedLeave.createdDate | date: "dd-MMM-yyyy" }}</td>
              <!-- <td></td> -->
              <td>{{ appliedLeave.reason }}</td>
              <td>{{ appliedLeave.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>
    </div>
    <br />

    <div id="mainContent" class="container">
    <div class="row p-2">
      <div class="col-md-4">
        <span class="bg-theme-title">Leave Summary</span>
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <button
          class="btn btn-xs btn-theme"
          style="float: right"
          matTooltip="Click to add new leave request"
          matTooltipPosition="left"
          (click)="openModal('add')"
        >
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;New Leave
          Request
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table table-striped table-bordered table-sm">
          <thead class="">
            <tr>
              <th>Sr.No.</th>
              <th>Leave Month</th>
              <th>Opening Balance</th>
              <th>Closing Balance</th>
              <th>Leaves Taken</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let leaveSummary of leaveSummaryList; index as i"
              id="leaveSummary_{{ i + 1 }}"
            >
              <td scope="row">
                {{ i + 1 }}
              </td>
              <td>{{ leaveSummary.month }}/{{ leaveSummary.year }}</td>
              <td>{{ leaveSummary.openingBalance }}</td>
              <td>{{ leaveSummary.closingBalance }}</td>
              <td>
                {{ leaveSummary.openingBalance - leaveSummary.closingBalance }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt" style="text-align: center;">
    <h5 class="modal-title" id="modal-basic-title" style="margin:5px;">Leave Request</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="modalForm">
      <div class="row">
        <label class="col-sm-4">Approver :</label>
        <div *ngIf="approverList.length > 0" class="col-sm-8">
          <select
            ngbAutofocus
            class="form-control form-control-xs"
            id="approver"
            name="approver"
            formControlName="approver"
            matTooltip="{{ formErrors.approver }}"
            matTooltipPosition="above"
            [class.is-invalid]="formErrors.approver && formSubmitted"
          >
            <option [ngValue]="null">Select Approver Name</option>
            <option *ngFor="let approver of approverList" [ngValue]="approver">
              {{ approver.firstName }} {{ approver.lastName }}
            </option>
          </select>
        </div>
        <div *ngIf="approverList.length == 0" class="col-sm-8">
          <input
            type="text"
            value="Self Approved"
            class="form-control form-control-xs"
            [disabled]="true"
          />
        </div>
      </div>

      <div class="row" >
        <label class="col-sm-4">Leave Type :</label>
        <div class="col-sm-8">
          <select
            ngbAutofocus
            class="form-control form-control-xs"
            id="leaveType"
            name="leaveType"
            formControlName="leaveType"
            matTooltip="{{ formErrors.leaveType }}"
            matTooltipPosition="above"
            [class.is-invalid]="formErrors.leaveType && formSubmitted"
          >
            <option [ngValue]="null">Select Leave Type</option>
            <option  
              *ngFor="let leaveType of leaveTypeList"
              [ngValue]="leaveType"
            >
            {{ leaveType.name }}
            </option>

          </select>
        </div>
      </div>

      <div class="row">
        <label class="col-sm-4">From Date :</label>
        <div class="col-sm-8">
          <div class="input-group" *ngIf="userRole=='Article';else elseBlock">
            <input
              class="form-control form-control-xs"
              placeholder="dd/mm/yyyy"
              name="fromDate"
              [minDate]="userJoiningDate"
              ngbDatepicker
              #fromDate="ngbDatepicker"
              formControlName="fromDate"
              [placement]="'bottom'"
              [class.is-invalid]="formErrors.fromDate && formSubmitted"
              matTooltip="{{ formErrors.fromDate }}"
              matTooltipPosition="above"
              matTooltipClass="warn-tooltip"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-theme calendar"
                (click)="fromDate.toggle()"
                type="button"
              ></button>
            </div>
          </div>
          <ng-template #elseBlock>
          <div class="input-group">
            <input
              class="form-control form-control-xs"
              placeholder="dd/mm/yyyy"
              name="fromDate"
              [minDate]="userJoiningDate"
              ngbDatepicker
              #fromDate="ngbDatepicker"
              formControlName="fromDate"
              [placement]="'bottom'"
              [class.is-invalid]="formErrors.fromDate && formSubmitted"
              matTooltip="{{ formErrors.fromDate }}"
              matTooltipPosition="above"
              matTooltipClass="warn-tooltip"
              [maxDate]="formatDate"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-theme calendar"
                (click)="fromDate.toggle()"
                type="button"
              ></button>
            </div>
          </div>
          </ng-template>
        </div>
      </div>

      <div class="row">
        <label class="col-sm-4">To Date :</label>
        <div class="col-sm-8">
          <div class="input-group" *ngIf="userRole=='Article';else elseBlock1">
            <input
              class="form-control form-control-xs"
              placeholder="dd/mm/yyyy"
              name="toDate"
              ngbDatepicker
              #toDate="ngbDatepicker"
              formControlName="toDate"
              [placement]="'bottom'"
              [class.is-invalid]="formErrors.fromDate && formSubmitted"
              matTooltip="{{ formErrors.toDate }}"
              matTooltipPosition="above"
              matTooltipClass="warn-tooltip"
              [minDate]="modalForm.value.fromDate"
              (ngModelChange)="onToDateChange()"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-theme calendar"
                (click)="toDate.toggle()"
                type="button"
              ></button>
            </div>
          </div>
          <ng-template #elseBlock1>
            <div class="input-group">
              <input
                class="form-control form-control-xs"
                placeholder="dd/mm/yyyy"
                name="toDate"
                ngbDatepicker
                #toDate="ngbDatepicker"
                formControlName="toDate"
                [placement]="'bottom'"
                [class.is-invalid]="formErrors.fromDate && formSubmitted"
                matTooltip="{{ formErrors.toDate }}"
                matTooltipPosition="above"
                matTooltipClass="warn-tooltip"
                [minDate]="modalForm.value.fromDate"
                (ngModelChange)="onToDateChange()"
                [maxDate]="formatDate"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-theme calendar"
                  (click)="toDate.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="row">
        <label class="col-sm-4">Leave Days :</label>
        <div class="col-sm-8">
          {{ this.modalForm.value.leaveDays }}
        </div>
      </div>

      <div class="row">
        <label class="col-sm-4">Reasons :</label>
        <div class="col-sm-8">
          <textarea
            style="overflow: auto; resize: none"
            rows="3"
            cols="20"
            id="reason"
            name="reason"
            type="text"
            class="form-control form-control-xs"
            formControlName="reason"
            [class.is-invalid]="formErrors.reason && formSubmitted"
            matTooltip="{{ formErrors.reason }}"
            matTooltipPosition="above"
          >
          </textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
    
      <div class="col-sm-3">
        <button
          id="saveLeaveBtn"
          name="saveLeaveBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onSubmitLeaveRequest()"
        >
          Save
        </button>
      </div>
      <div class="col-sm-3">
        <button
          id="closeLeaveBtn"
          name="closeLeaveBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="closeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!--
  <table class="table table-responsive-md table-sm">
        <thead class="">
          <tr>
            <th>#</th>
            <th>Approver Name</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Number Of Days</th>
            <th>Leave Type</th>
            <th>Leave Request Date</th>
            <th>Balance</th>
            <th>Reason</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fyWeek of financialYearsWeekList; index as i" id="branch_{{i+1}}">
            <th scope="row">
              <input type="radio" [(ngModel)]="radioSelected" name="list_name" [value]="i" (change)="onWeekChange(fyWeek)"/>
            </th>
            <td>{{fyWeek.weekStartDate | date: 'dd-MMM-yyyy'}}</td>
            <td>{{fyWeek.weekEndDate | date: 'dd-MMM-yyyy'}}</td>
            <td>{{fyWeek.status}}</td>
            <td>{{fyWeek.diarySubmittedDate | date: 'dd-MMM-yyyy'}}</td>
            <td>{{fyWeek.diaryApprovalDate | date: 'dd-MMM-yyyy'}}</td>
          </tr>
        </tbody>
      </table> -->
